import { render, staticRenderFns } from "./customer_sources.vue?vue&type=template&id=7890ae5a"
import script from "./customer_sources.vue?vue&type=script&lang=js"
export * from "./customer_sources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports